import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { InquiryConfirmationModalStyles } from './InquiryConfirmationModal.styles';
import { Ports } from 'src/components/common/Types/CommonTypes';

interface RouteInfoWithFlagProps extends
  StylesProps<ReturnType<typeof InquiryConfirmationModalStyles>> {
    origin: Ports;
    destination: Ports;
    lineStyle?: ElementCSSInlineStyle;
    portStyle?: ElementCSSInlineStyle;
}

const RouteInfoWithFlag = (props: RouteInfoWithFlagProps): React.ReactElement => {

  const {
    classes,
    origin,
    destination,
    lineStyle,
    portStyle,
  } = props;

  const renderLine = (): React.ReactElement => {
    return <div className={classes.line}/>;
  };

  const renderDot = (styles): React.ReactElement => {
    return <div className={classes.dot} style={{...styles, height: '9px', width: '9px' }} />;
  };

  const renderPortInfo = (lineStyle) : React.ReactElement => {
    return (
      <div style={{ padding: '0px 12%', height: '16px' }} className={classes.portDiv}>
        <div className={classes.lineStyle} style={{...lineStyle}}>
          {renderDot({ backgroundColor: '#979797' })}
          {renderLine()}
          {renderDot({})}
        </div>
        <div className={classes.port} style={{ width: '92%' }}>
          <div className={classes.polDiv}>
            <img src={origin?.flagS3Link} className={classes.portFlag} />
            <span className={classes.polName}>
              {origin?.name}
            </span>
          </div>
          <div className={classes.pod}>
            <img src={destination?.flagS3Link} className={classes.portFlag} />
            <span className={classes.polName}>
              {destination?.name}
            </span>
          </div>
        </div>
      </div>
    );
  };
  
  return (
    renderPortInfo(lineStyle)
  );
};

export default withStyles(InquiryConfirmationModalStyles)(RouteInfoWithFlag);
